// These are consolidated status of both cart and addresses status
export const ERROR = 'error';
export const FINISHED = 'finished';
export const IDLE = 'idle';
export const LOADING = 'loading';
export const SAVING = 'saving';
export const SUCCESS = 'success';
